import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRouteSnapshot, NavigationEnd, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { HhsgSharedBreadcrumbItem } from '../../models';
import {RouteUtil} from "../../../utilities/route.util";
import {HOME} from "@angular/cdk/keycodes";

@Component({
  selector: 'hhsg-breadcrumbs',
  templateUrl: 'breadcrumbs.component.html',
  styleUrls: ['breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  @Input() breadcrumbList: HhsgSharedBreadcrumbItem[] = [];
  @Input() auto: boolean = false;
  @Input() hideHome: boolean = false;
  @Input() rootBreadcrumb: HhsgSharedBreadcrumbItem = {
    name: 'Home',
    path: '/home',
    routeExists: true
  };

  private routeSnapshot: ActivatedRouteSnapshot;
  private routeSubscription: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.routeSnapshot = this.router.routerState.snapshot.root;

    this.initRouteEvents();
  }

  private initRouteEvents() {
    if (this.auto) {
      this.setBreadcrumbs();
      this.routeSubscription = this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.setBreadcrumbs();
        }
      });
    }
  }

  private setBreadcrumbs() {
    let breadcrumbList: HhsgSharedBreadcrumbItem[];

    let routeData = this.routeSnapshot;
    while (routeData) {
      const path = routeData.data?.path ?? routeData.url[0]?.path;
      const name = routeData.data?.breadcrumbName;
      const textOnly = routeData.data?.textOnly;
      this.hideHome = this.hideHome || routeData.data?.hideHome;

      if (name && path) {
        if(!breadcrumbList) {
          breadcrumbList = this.hideHome ? [] : [this.rootBreadcrumb];
        }

        let pathFromRoot = this.getPathFromRoot(routeData);
        let routeExists = this.routeExists(textOnly, path);
        this.addBreadCrumbIfNew(name, breadcrumbList, pathFromRoot, routeExists);
      }

      routeData = routeData.children[0];
    }

    this.breadcrumbList = breadcrumbList;
  }

  addBreadCrumbIfNew(name: string, breadcrumbList: HhsgSharedBreadcrumbItem[], pathFromRoot: string, routeExists:boolean) {
    const breadCrumbExists = breadcrumbList.findIndex(
      (item) => item.name === name && item.path === pathFromRoot
    ) >= 0;

    // If we don't already have a route, push it to the crumbs:
    if (!breadCrumbExists) {
      breadcrumbList.push({ name, path: pathFromRoot, routeExists: routeExists });
    }
  }

  getPathFromRoot(routeData: ActivatedRouteSnapshot): string {
    const pathFromRoot = routeData.pathFromRoot
      .map((p) => p.url[0]?.toString() ?? '')
      .join('/');

    return pathFromRoot;
  }

  // 1. If the route is text only return false so it is not rendered as a link.
  // 2. If the route doesn't exist return false so it is not rendered as a link.
  routeExists(textOnly: boolean, path: any): boolean {
    return textOnly ? false : RouteUtil.routeExists(this.router, path);
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
